import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, fmt } from '../api';

export default function Products() {
  const [rows, setRows] = useState<any[]>([]);
  const [title, setTitle] = useState('');
  const [price, setPrice] = useState('');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const refresh = () => api.products().then(setRows);
  useEffect(() => {
    refresh();
  }, []);

  async function addProduct(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setMessage(null);
    const amount = Number(price);
    if (!title.trim() || !Number.isFinite(amount) || amount <= 0) {
      setError('Enter a product name and a price greater than zero.');
      return;
    }
    setSaving(true);
    try {
      await api.addProducts([{ title: title.trim(), priceCents: Math.round(amount * 100) }]);
      setTitle('');
      setPrice('');
      setMessage('Product added and validated.');
      await refresh();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <>
      <h2 className="page-title">Product Intelligence</h2>
      <p className="page-sub">Ranked by revenue + ad-fit. Launch in one click from any product.</p>
      <form className="card card-padded" style={{ maxWidth: 720, marginBottom: 20 }} onSubmit={addProduct}>
        <h3 style={{ marginTop: 0 }}>Add a product</h3>
        <p style={{ color: 'var(--text-sub)', fontSize: 13 }}>Add one product now. A title and positive price are required before campaign setup.</p>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr auto', gap: 10, alignItems: 'end' }}>
          <div className="field" style={{ marginBottom: 0 }}>
            <label>Product name</label>
            <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Meta Review Test Product" />
          </div>
          <div className="field" style={{ marginBottom: 0 }}>
            <label>Price (AUD)</label>
            <input value={price} onChange={(e) => setPrice(e.target.value)} inputMode="decimal" placeholder="29.00" />
          </div>
          <button className="btn btn-primary" type="submit" disabled={saving}>{saving ? 'Adding…' : 'Add product'}</button>
        </div>
        {message && <div style={{ marginTop: 10, color: 'var(--success)' }}>{message}</div>}
        {error && <div style={{ marginTop: 10, color: 'var(--danger)' }}>{error}</div>}
      </form>
      {rows.length === 0 && <div className="empty">No products yet. Add the review product above to continue.</div>}
      <div className="product-grid">
        {rows.map((p) => (
          <div key={p.id} className="product-card">
            <div className="img" style={{ backgroundImage: `url(${p.image_url})` }} />
            <div className="body">
              <div className="title">{p.title}</div>
              <div className="meta">{fmt.money(p.price_cents)} · {fmt.num(p.units_sold_30d)} sold</div>
              <div className="fit-meter">
                <span style={{ width: `${p.ad_fit_score}%` }} />
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 11, color: 'var(--text-mute)' }}>Ad-fit {p.ad_fit_score}/100</span>
                {p.is_bestseller ? (
                  <span className="badge badge-active">Bestseller</span>
                ) : null}
              </div>
              <div style={{ marginTop: 10, fontSize: 13, fontWeight: 600 }}>
                {fmt.moneyShort(p.revenue_30d_cents)} <span style={{ color: 'var(--text-sub)', fontSize: 11, fontWeight: 400 }}>30d revenue</span>
              </div>
              <Link to="/app/campaigns/new" className="btn btn-primary btn-small" style={{ marginTop: 10, width: '100%', justifyContent: 'center' }}>
                Launch campaign
              </Link>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
